import { useMemo, useCallback } from 'react';

import { NameAndCreateDateFormatter, getInfo } from '@/components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid';
import column, { defaultActionsColumn, defaultColumn, defaultColumnId, deleteAction, editAction } from '@Components/Grid/utils/column';
import { PureSwitch as Switch } from 'components/form/Switch';

const TwoFactorAuthenticationToggle = ({ info }) => {
  const { events: { handleUpdate2FA } } = useGrid()
  const id = info.row.original.twoFactorAuthentication?.id

  return <Switch name="_" value={id} disabled={!id} onChange={() => handleUpdate2FA(id)} />
}

const ToggleFormatter = ({ info }) => {
  const { row, field, value } = getInfo(info)
  const { events: { handleUpdateEntry } } = useGrid()

  const handleUpdateActive = useCallback(() => {
    const { id, isSuperAdmin, isManagerAdmin, is_admin } = row
    handleUpdateEntry({ id, isSuperAdmin, isManagerAdmin, is_admin, [field]: !value })
  }, [handleUpdateEntry, field, row, value])

  return <Switch value={value} onChange={handleUpdateActive} />
}

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('email', 'Email', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('first_name', 'First Name'),
    defaultColumn('last_name', 'Last Name'),
    column.accessor('isSuperAdmin', {
      header: 'Super Admin',
      cell: info => <Switch value={!!info.getValue()} disabled />,
      defaultVisible: false,
      enableColumnResize: false,
    }),
    column.accessor('isManagerAdmin', {
      header: 'Manager Admin',
      cell: info => <Switch value={!!info.getValue()} disabled />,
      defaultVisible: false,
      enableColumnResize: false,
    }),
    column.accessor('2fa', {
      header: '2fa',
      cell: info => <TwoFactorAuthenticationToggle info={info} />,
      enableSorting: false,
      enableColumnResize: false,
      maxSize: 80,
    }),
    defaultColumn('active', 'Active', info => <ToggleFormatter info={info} />, { enableColumnResize: false, maxSize: 80 }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
